import React, { useState, useRef } from 'react';
import { Search } from 'lucide-react';

const ExpandableSearchBar = ({ searchTerm, onSearchChange, placeholder = "Search", fullWidth = false, className = "", ...props }) => {
    const [isSearchExpanded, setIsSearchExpanded] = useState(false);
    const inputRef = useRef(null);

    const isExpanded = isSearchExpanded || searchTerm || fullWidth;

    return (
        <div
            className={`relative flex items-center bg-white border border-gray-200 transition-all duration-500 ease-in-out shadow-sm ${isExpanded
                ? `${fullWidth ? 'w-full' : 'w-96'} rounded-xl`
                : 'w-12 h-12 rounded-full justify-center cursor-pointer hover:shadow-md'
                } ${className}`}
            onClick={() => {
                if (!isExpanded) {
                    setIsSearchExpanded(true);
                    setTimeout(() => inputRef.current?.focus(), 100);
                }
            }}
        >
            <div
                className={`flex items-center justify-center flex-shrink-0 ${isExpanded ? 'pl-4' : 'w-full h-full'
                    }`}
            >
                <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
                {...props}
                ref={inputRef}
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                onBlur={() => {
                    if (!searchTerm && !fullWidth) setIsSearchExpanded(false);
                }}
                className={`w-full bg-transparent border-none focus:outline-none text-gray-700 placeholder-gray-400 px-4 py-3 transition-all duration-300 ${isExpanded ? 'opacity-100' : 'opacity-0 w-0 p-0 hidden'
                    }`}
            />
        </div>
    );
};

export default ExpandableSearchBar;
